import { formatDate } from '@/shared/utils/format';

export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;
export const WEEK_IN_MS = 7 * DAY_IN_MS;
export const MONTH_IN_MS = 30 * DAY_IN_MS;
export const YEAR_IN_MS = 365 * DAY_IN_MS;

export const serializeDate = (date: Date) => {
  return formatDate({
    date,
    formatType: 'iso',
  });
};

export const getYearMonthOnly = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const getLastMonthRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastDayOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

  const start = new Date(lastMonth);
  start.setHours(0, 0, 0, 0);

  const end = new Date(lastDayOfLastMonth);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

export const getLastQuarterRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentQuarter = Math.floor(currentMonth / 3);

  // Calculate last quarter
  let lastQuarterMonth: number;
  let lastQuarterYear: number;

  if (currentQuarter === 0) {
    // Current is Q1, last quarter is Q4 of previous year
    lastQuarterMonth = 9; // October (0-indexed)
    lastQuarterYear = now.getFullYear() - 1;
  } else {
    // Last quarter is previous quarter of current year
    lastQuarterMonth = (currentQuarter - 1) * 3;
    lastQuarterYear = now.getFullYear();
  }

  const start = new Date(lastQuarterYear, lastQuarterMonth, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(lastQuarterYear, lastQuarterMonth + 3, 0);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

export const getLastYearRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const lastYear = now.getFullYear() - 1;

  const start = new Date(lastYear, 0, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(lastYear, 11, 31);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

export const getThisMonthRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

  const start = new Date(firstDayOfMonth);
  start.setHours(0, 0, 0, 0);

  const end = new Date(now);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

export const getThisQuarterRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const currentQuarter = Math.floor(currentMonth / 3);

  const quarterStartMonth = currentQuarter * 3;
  const quarterStartYear = now.getFullYear();

  const start = new Date(quarterStartYear, quarterStartMonth, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(now);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

export const getThisYearRange = (): { start: Date; end: Date } => {
  const now = new Date();
  const currentYear = now.getFullYear();

  const start = new Date(currentYear, 0, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(now);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};
